import React, { forwardRef, useEffect, useState } from 'react';
import classnames from 'classnames';
import { IconUploadCloud02, IconFileJPG } from '@pentabd/icons';
import Text from '../text/Text';
import Avatar from '../avatar/Avatar';

export interface FileUploadProps {
  testId?: string;
  status?:
    | 'info'
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'warning'
    | 'success'
    | 'dark'
    | 'default';
  id: string;
  name: string;
  fileTypesText?: string;
  maxSizeText?: string;
  jpgFileFormatIcon?: boolean;
  onDragOver?: (event: React.DragEvent<HTMLDivElement>) => void;
  onDrop?: (event: React.DragEvent<HTMLDivElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  defaultValue?: string;
  image?: boolean;
  buttonText?: string;
  disabled?: boolean;
}

// eslint-disable-next-line react/display-name
export const FileUpload = forwardRef<HTMLInputElement, FileUploadProps>(
  (
    {
      testId,
      id,
      name,
      status,
      fileTypesText,
      maxSizeText,
      jpgFileFormatIcon,
      onDragOver,
      onDrop,
      className,
      defaultValue,
      onChange,
      image,
      buttonText = 'Click to Upload',
      disabled,
    }: FileUploadProps,
    ref,
  ) => {
    const [file, setFile] = useState(defaultValue);

    const onChangeFile = (e) => {
      if (e.target.files && e.target.files.length > 0) {
        setFile(URL.createObjectURL(e.target.files[0]));
        // let file = e.target.files[0];

        // getBase64(file)
        //   .then((result) => {
        //     file['base64'] = result;
        //   })
        //   .catch((err) => {});
      }
      onDrop && onDrop(e);
      onDragOver && onDragOver(e);
      onChange && onChange(e);
    };

    useEffect(() => {
      if (defaultValue) {
        setFile(defaultValue);
      }
    }, [defaultValue]);

    return (
      <label>
        <div
          className={classnames('d-flex gap-6', { 'opacity-50': disabled })}
          data-testid={testId}
        >
          {image && <Avatar imageURL={file} />}
          <div
            className={classnames(
              `file-upload border border-${status} w-100 px-12 py-8 pointer rounded-6`,
              className,
            )}
          >
            <div
              className="d-flex flex-column align-items-center position-relative gap-6"
              onDragOver={onDragOver}
              onDrop={onDrop}
            >
              <div className="shadow-xs d-flex align-items-center justify-content-center p-5 border rounded-4">
                <IconUploadCloud02 size="20" />
              </div>
              <div className="w-100">
                <div className="w-100 d-flex justify-content-center align-items-center">
                  <input
                    name={name}
                    type="file"
                    multiple
                    ref={ref}
                    id={id || 'file'}
                    onDragOver={onChangeFile}
                    onDrop={onChangeFile}
                    onChange={onChangeFile}
                    disabled={disabled}
                  />
                  <Text size="sm" color="info" weight="semibold">
                    {buttonText}
                  </Text>
                  {/* <Text color="subtitle1" size="sm">
                    &nbsp;or drag and drop
                  </Text> */}
                </div>
                <div className="w-100 d-flex justify-content-center align-items-center">
                  {fileTypesText ? (
                    <Text color="subtitle1" size="xs">
                      {fileTypesText}
                    </Text>
                  ) : null}
                  {maxSizeText ? (
                    <Text color="subtitle1" size="xs">
                      &nbsp;({maxSizeText})
                    </Text>
                  ) : null}
                </div>
              </div>

              {jpgFileFormatIcon && (
                <div className="position-absolute bottom-0 right-0">
                  <IconFileJPG />
                </div>
              )}
            </div>
          </div>
        </div>
      </label>
    );
  },
);
